import { render, staticRenderFns } from "./ReviewAuthorisedUnfundedBatches.vue?vue&type=template&id=67935b46&"
import script from "./ReviewAuthorisedUnfundedBatches.vue?vue&type=script&lang=ts&"
export * from "./ReviewAuthorisedUnfundedBatches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports